import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

/*
  DEV BYPASS:
  set this to true while building locally if you do not want to keep logging in.
  set it to false before launch.
*/
const DEV_BYPASS_AUTH = false;

function ProtectedRoute({ children }) {
  const [checking, setChecking] = useState(!DEV_BYPASS_AUTH);
  const [user, setUser] = useState(DEV_BYPASS_AUTH ? { uid: "dev-user" } : null);

  useEffect(() => {
    if (DEV_BYPASS_AUTH) return;

    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setChecking(false);
    });

    return () => unsubscribe();
  }, []);

  if (DEV_BYPASS_AUTH) {
    return children;
  }

  if (checking) {
    return <div style={{ padding: "40px", color: "white" }}>Checking session...</div>;
  }

  if (!user) {
    window.location.href = "/login";
    return null;
  }

  return children;
}

export default ProtectedRoute;